var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1151.6 948.38-139.12-138.75v-434.62c0-10.125-4.125-19.5-10.875-26.625l-300-300c-3.375-3.375-7.5-6.375-12-8.25-4.875-1.5-9.75-2.625-14.625-2.625h-600c-20.625 0-37.5 16.875-37.5 37.5v900c0 20.625 16.875 37.5 37.5 37.5h734.62l139.12 139.12c7.125 7.125 16.5 10.875 26.25 10.875s19.125-3.75 26.625-10.875l150-150c14.625-14.625 14.625-38.625 0-53.25zm-300 0-101.62-101.25v-97.125h97.125l150 150-97.125 97.125zm-589.12-835.88h375v225h-375zm-150 0h75v262.5c0 20.625 16.875 37.5 37.5 37.5h450c20.625 0 37.5-16.875 37.5-37.5v-209.62l225 225v343.88l-48.375-48.375c-7.125-6.75-16.5-10.875-26.625-10.875v-150c0-20.625-16.875-37.5-37.5-37.5h-600c-20.625 0-37.5 16.875-37.5 37.5v412.5h-75zm150 825v-375h525v112.5h-75c-20.625 0-37.5 16.875-37.5 37.5v150c0 10.125 4.125 19.5 10.875 26.625l48.75 48.375zm712.5 134.62-22.125-22.125 97.125-97.125 22.125 22.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAs);
export default __webpack_public_path__ + "static/media/save-as.3825c44648a8c9df1c21c58661f9c440.svg";
export { ForwardRef as ReactComponent };